// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flights-wrapper{background-color:#ebeef2}.flights-wrapper .flights-container{display:grid;grid-template-columns:1fr;grid-gap:10px;grid-auto-rows:auto}.flights-wrapper .flights-main,.flights-wrapper .flights-search{grid-column:1}.flights-wrapper .flights-main .flights-suggest{display:grid;grid-template-columns:repeat(3 1fr);grid-gap:10px;grid-auto-rows:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
